import React from "react";
import PricingUI from "../PricingUI";

type PriceErrorsProps = {
    error_messages: string;
    msrp: number;
    quoteId: number;
}


const PriceErrors = ({ error_messages, msrp, quoteId} : PriceErrorsProps) => {
    if( (msrp ?? 0) === 0) {
        return (
            <div className="price-error text-center">
                <h6>{error_messages ?? "Something went wrong"}</h6>
            </div>
        );
    } else {
        return (
            <div className="price-success text-center">
                <h4 title={""}>{<PricingUI 
                    quoteId={quoteId}
                    msrp={msrp}
                />}</h4>
            </div>
        );
    }
};

export default PriceErrors;
